import * as React from 'react'
import { Text } from '@doordash/design-language'
import CircleIcon from '../components/CircleIcon'
import ListCell from '@doordash/component-list-cell'

const BulletListCell = ({ text }) => (
  <ListCell
    renderBeforeContent={() => <CircleIcon color={'black'} size={6} />}
    insetSize={ListCell.InsetSizes.None}
    isSeparatorVisible={false}
    subtext={<Text styles={Text.Styles.PageSubtext}>{text}</Text>}
    subtextMaxLines={10}
  />
)

export default BulletListCell
